<template>
    <div>

        <div class="form-row mb-1" v-if="laudo_pode_alterar">

            <div class="col col-12 col-md-6 d-flex flex-column">

                <button type="button" class="btn btn-outline-dark btn-sm" 
                    @click="anexar_laudo()"
                    :disabled="( $store.state.loading || tem_partes ) ? true : false">
                    <i class="fas fa-file-medical mr-2" v-if="!$store.state.loading"></i>
                    <div class="spinner-border spinner-border-sm mr-2" role="status" v-else>
                        <span class="sr-only">Loading...</span>
                    </div>
                    Anexar Laudo Externo
                </button>
                
            </div>

            <div class="col col-12 col-md-6 d-flex flex-column">

                <div class="btn-group" role="group">

                    <button type="button" class="btn btn-outline-secondary btn-sm" 
                        @click="anexar_laudo('anexo')"
                        :disabled="$store.state.loading">
                        <i class="fas fa-paperclip mr-2" v-if="!$store.state.loading"></i>
                        <div class="spinner-border spinner-border-sm mr-2" role="status" v-else>
                            <span class="sr-only">Loading...</span>
                        </div>
                        Anexar Documento Complementar
                    </button>

                    <button type="button" class="btn btn-sm ml-1" 
                        v-if="1==0 && laudo_arq.arquivos && laudo_arq.arquivos.find(arq => arq.fl_key)"
                        :class="laudo_arq.fl_imp_keys ? 'btn-secondary' : 'btn-outline-secondary'"
                        @click="laudo_arq.fl_imp_keys = !laudo_arq.fl_imp_keys"  
                        :disabled="$store.state.loading" 
                        title="Imprimir Imagens Chave"
                        style="max-width: 30px;">
                        <i class="fa-solid fa-key"></i>
                    </button>

                </div>

            </div>

        </div>

        <template v-if="laudo_arq && laudo_arq.laudo_entregas && laudo_arq.laudo_entregas.length">
            <div class="card">
                <div class="card-header d-flex justify-content-between">
                    <div>
                        <a class="card-link" data-toggle="collapse" href="#collapseEntregaResultado" role="button" aria-expanded="false" aria-controls="collapseExample">
                            Entrega de Resultado
                        </a>
                    </div>
                    <div><span class="badge badge-secondary">{{ laudo_arq.laudo_entregas.length }}</span></div>
                </div>
                <div class="collapse" id="collapseEntregaResultado">
                    <ul class="list-group">
                        <li class="list-group-item" v-for="(entrega, iex) in laudo_arq.laudo_entregas" :key="'E' + iex">
                            Entrega realizada para {{ entrega.st_nome_recebedor }} 
                            em {{ $util.getFormatDate(entrega.created_at) }} às {{ entrega.created_at.substr(11,5) }}
                            <div>Por: {{ entrega.usuario.st_login }}</div>
                            <div class="small text-muted">{{ entrega.st_local }}</div>        
                        </li>
                    </ul>
                </div>
            </div>
        </template>

        <template v-if="laudo_arq && laudo_arq.arquivos && laudo_arq.arquivos.length">
            <visualizar-laudo-externo :atp="{ laudo: laudo_arq }" :pode_alterar="laudo_pode_alterar" />
        </template>

        <div v-if="acao_anexar">
            <az-file-upload
                ref="uploadlaudo"
                :multiple="true"
                :extensions="tipo_especial == 'anexo' ? '' : 'pdf'"
                @refresh="$emit('refresh')"
                :arquivos="arquivos ? arquivos : []" 
                :model="laudo_arq"
                :parms="{ 
                    model_type: 'laudo', 
                    model_id: laudo_arq ? laudo_arq.id_laudo : null,
                    tipo_especial: tipo_especial, 
                    fechar_ao_enviar: true 
                }" />
        </div>

    </div>
</template>

<script>
import AzFileUpload from "../../util/AzFileUpload.vue";
import VisualizarLaudoExterno from '../consultorio/VisualizarLaudoExterno.vue';

export default {
    data() { 
        return { 
            acao_anexar: false, 
            arquivos: false, 
            tipo_especial: "",
        };
    },

    components: {
        AzFileUpload,
        VisualizarLaudoExterno,
    },

    computed: { 
        laudo_pode_alterar: function () { 
            return this.laudo_arq && this.pode_alterar && !this.laudo_arq.doc_certificado_link && ( !this.laudo_arq.status_laudo || ( !this.laudo_arq.status_laudo.fl_pronto && !this.laudo_arq.status_laudo.fl_revisao ) );
        }
    },

    props: ['laudo_arq', 'pode_alterar', 'tem_partes'],

    methods: { 
        anexar_laudo (tipo = "") { 
            this.tipo_especial = tipo;
            this.acao_anexar = null;

            this.$nextTick(() => { 
                this.acao_anexar = true;
                
                this.$nextTick(() => {
                    this.carregar_arquivos(true);
                });
            });
        },

        carregar_arquivos (abrir = false) { 

            if ( !this.laudo_arq ) { 
                alert('Falha na identificação do laudo.')
                return;
            }

            this.$store.commit('loading', true);

            this.$util.loadItem(this, { 
                service: 'arquivos',
                func: 'links',
                parms: { 
                id: this.laudo_arq.id_laudo, 
                type: 'laudo',
                }
            })
            .then(res => { 
                this.arquivos = res;

                if ( abrir ) { 
                    this.$nextTick(() => { 
                        this.$refs.uploadlaudo.abrir();
                    });
                }
            })
            .finally(() => { 
                this.$store.commit('loading', false);
            });

        },

    }
}
</script>